import clsx from 'clsx';
import { Bell, CircleAlert, LoaderCircle } from 'lucide-react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNotifications } from '../notifications.context';
import { useUser } from 'hooks/useUser';

const NotificationsIcon = () => {
  const { t } = useTranslation('Notifications');
  const [retries, setRetries] = useState<number>(0);
  const user = useUser();
  const {
    popOverisOpen,
    unReadNotifications,
    isGetUnreadNotificationsBusy,
    isGetUnreadNotificationsError,
    refetchAll,
  } = useNotifications();

  useEffect(() => {
    if (isGetUnreadNotificationsError && retries < 4) {
      refetchAll();
      setRetries(retries + 1);
    }
  }, [user, unReadNotifications, isGetUnreadNotificationsBusy, isGetUnreadNotificationsError]);

  if (isGetUnreadNotificationsBusy) {
    return (
      <div>
        <LoaderCircle />
      </div>
    );
  }

  if (isGetUnreadNotificationsError) {
    return (
      <div>
        <CircleAlert />
      </div>
    );
  }

  return (
    <div className={clsx('relative flex', 'cursor-pointer', popOverisOpen ? 'text-primary-500' : '')}>
      <Bell />
      {unReadNotifications && unReadNotifications.length ? (
        <span
          className={clsx(
            'absolute -top-2 -right-2',
            'flex items-center justify-center',
            'h-5 w-5 rounded-full',
            'bg-red-500 text-white',
            'border-[1px] border-gray-100',
            'cursor-pointer',
          )}
        >
          <span
            className={clsx(
              unReadNotifications.length > 100 ? 'text-[0.5rem]' : unReadNotifications.length > 10 ? 'text-xs' : '',
            )}
          >
            {unReadNotifications.length}
          </span>
        </span>
      ) : null}

      <div className="hidden group-hover:block">
        <span className="hubert-vertical-center ml-2">{t('iconLabel')}</span>
      </div>
    </div>
  );
};

export default NotificationsIcon;
